<template>
    <div class="flex row">
        <div class="table_wrap">
            <h1>모니터링 채팅방 수</h1>
            <table class="board_table">
                <thead>
                    <tr>
                        <th>텔레그램</th>
                        <th>디스코드</th>
                        <th>카카오톡</th>
                        <th>기타</th>
                        <th>합계</th>
                    </tr>
                </thead>
                <tbody v-if="!props.loading && chartData.room">
                    <td>{{ table.room.telegram.toLocaleString() }}</td>
                    <td>{{ table.room.discord.toLocaleString() }}</td>
                    <td>{{ table.room.kakaoTalk.toLocaleString() }}</td>
                    <td>{{ table.room.etc.toLocaleString() }}</td>
                    <td>{{ table.room.total.toLocaleString() }}</td>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td :colspan="10">
                            <Spinner />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="board_graph_list">
            <template v-if="!props.loading">
                <Chart style="height: 150px" v-for="data in chartData.room" :defaultLayout="chartLayout" :data="data"></Chart>
            </template>
            <Spinner v-else></Spinner>
        </div>
    </div>
    <div class="flex row">
        <div class="table_wrap">
            <h1>모니터링 수(캡쳐 수)</h1>
            <table class="board_table">
                <thead>
                    <tr>
                        <th>텔레그램</th>
                        <th>디스코드</th>
                        <th>카카오톡</th>
                        <th>기타</th>
                        <th>합계</th>
                    </tr>
                </thead>
                <tbody v-if="!props.loading && chartData.room">
                    <td>{{ table.bot.telegram.toLocaleString() }}</td>
                    <td>{{ table.bot.discord.toLocaleString() }}</td>
                    <td>{{ table.bot.kakaoTalk.toLocaleString() }}</td>
                    <td>{{ table.bot.etc.toLocaleString() }}</td>
                    <td>{{ table.bot.total.toLocaleString() }}</td>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td :colspan="10">
                            <Spinner />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="board_graph_list">
            <template v-if="!props.loading">
                <Chart style="height: 150px" v-for="data in chartData.bot" :defaultLayout="chartLayout" :data="data"></Chart>
            </template>
            <Spinner v-else></Spinner>
        </div>
    </div>
    <div class="flex row">
        <div class="table_wrap">
            <h1>탐지 수</h1>
            <table class="board_table">
                <thead>
                    <tr>
                        <th>텔레그램</th>
                        <th>디스코드</th>
                        <th>카카오톡</th>
                        <th>기타</th>
                        <th>합계</th>
                    </tr>
                </thead>
                <tbody v-if="!props.loading && chartData.room">
                    <td>{{ table.detect.telegram.toLocaleString() }}</td>
                    <td>{{ table.detect.discord.toLocaleString() }}</td>
                    <td>{{ table.detect.kakaoTalk.toLocaleString() }}</td>
                    <td>{{ table.detect.etc.toLocaleString() }}</td>
                    <td>{{ table.detect.total.toLocaleString() }}</td>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td :colspan="10">
                            <Spinner />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="board_graph_list">
            <template v-if="!props.loading">
                <Chart style="height: 150px" v-for="data in chartData.detect" :defaultLayout="chartLayout" :data="data"></Chart>
            </template>
            <Spinner v-else></Spinner>
        </div>
    </div>
</template>

<script lang="ts" config>
    import {
        Chart,
        numberFormat,
        reactive,
        LayoutOption,
        Spinner,
        ref,
        ChartData,
        onMounted,
        watch,
        NoResult,
        setChartData,
        ChartSort,
    } from "@/BaseComponent";
    interface PropsData {
        room: [{ platform: number; cnt: number; cntDetect: number }];
        bot: [{ platform: number; cnt: number }];
    }
    export default {
        props: {
            loading: Boolean,
            chartData: Object,
        },
        components: {
            Chart,
            Spinner,
            NoResult,
        },
        setup(props: any) {
            const table = reactive({
                room: { telegram: 0, discord: 0, kakaoTalk: 0, etc: 0, total: 0 },
                bot: { telegram: 0, discord: 0, kakaoTalk: 0, etc: 0, total: 0 },
                detect: { telegram: 0, discord: 0, kakaoTalk: 0, etc: 0, total: 0 },
            });
            const chartLayout = reactive({
                type: "bar",
                xAxisKey: "name",

                title: { text: "" },

                valueUnit: "개", // 값의 단위
                useLegend: true, // 범례 표시 여부
                useToolbox: false, //다운로드 기능

                isRowChart: true,
                grid: { top: "19%" },
            } as LayoutOption);

            const chartData = reactive({
                room: [] as ChartData[],
                bot: [] as ChartData[],
                detect: [] as ChartData[],
            });

            const platformList = [
                { idx: 1, name: "텔레그램" },
                { idx: 2, name: "디스코드" },
                { idx: 3, name: "기타" },
                { idx: 4, name: "카카오톡" },
            ];

            const roomChartSort: ChartSort[] = [
                { name: "1", valueKey: "cnt" },
                { name: "2", valueKey: "cnt" },
                { name: "3", valueKey: "cnt" },
                { name: "4", valueKey: "cnt" },
            ];

            const botChartSort: ChartSort[] = [
                { name: "1", valueKey: "cnt" },
                { name: "2", valueKey: "cnt" },
                { name: "3", valueKey: "cnt" },
                { name: "4", valueKey: "cnt" },
            ];

            const detectChartSort: ChartSort[] = [
                { name: "1", valueKey: "cntDetect" },
                { name: "2", valueKey: "cntDetect" },
                { name: "3", valueKey: "cntDetect" },
                { name: "4", valueKey: "cntDetect" },
            ];
            onMounted(() => {
                init();
                if (props.chartData) setData(props.chartData);
            });

            watch(
                () => props.chartData,
                (newData) => {
                    init();
                    if (newData) setData(newData);
                },
            );

            const init = () => {
                chartData.room = [];
                chartData.bot = [];
                chartData.detect = [];
            };

            const setData = (data: PropsData) => {
                setTableData(data);
                chartData.room.push(setChartData(roomChartSort, data.room, ""));
                chartData.bot.push(setChartData(botChartSort, data.bot, ""));
                chartData.detect.push(setChartData(detectChartSort, data.room, ""));
                setPlatformName();
            };

            const setPlatformName = () => {
                chartData.room = chartData.room.map((item) => {
                    return {
                        ...item,
                        data: item.data.map((value) => {
                            return { ...value, name: platformList.find((platform) => platform.idx.toString() == value.name)?.name ?? "" };
                        }),
                    };
                });
                chartData.bot = chartData.bot.map((item) => {
                    return {
                        ...item,
                        data: item.data.map((value) => {
                            return { ...value, name: platformList.find((platform) => platform.idx.toString() == value.name)?.name ?? "" };
                        }),
                    };
                });
                chartData.detect = chartData.detect.map((item) => {
                    return {
                        ...item,
                        data: item.data.map((value) => {
                            return { ...value, name: platformList.find((platform) => platform.idx.toString() == value.name)?.name ?? "" };
                        }),
                    };
                });
            };

            const setTableData = (data: PropsData) => {
                data.room.forEach((item) => {
                    if (item.platform == 1) (table.room.telegram = item.cnt), (table.detect.telegram = item.cntDetect);
                    else if (item.platform == 2) (table.room.discord = item.cnt), (table.detect.discord = item.cntDetect);
                    else if (item.platform == 3) (table.room.etc = item.cnt), (table.detect.etc = item.cntDetect);
                    else if (item.platform == 4) (table.room.kakaoTalk = item.cnt), (table.detect.kakaoTalk = item.cntDetect);
                });
                data.bot.forEach((item) => {
                    if (item.platform == 1) table.bot.telegram = item.cnt;
                    else if (item.platform == 2) table.bot.discord = item.cnt;
                    else if (item.platform == 3) table.bot.etc = item.cnt;
                    else if (item.platform == 4) table.bot.kakaoTalk = item.cnt;
                });
                table.room.total = data.room.reduce((sum, num) => sum + num.cnt, 0);
                table.detect.total = data.room.reduce((sum, num) => sum + num.cntDetect, 0);
                table.bot.total = data.bot.reduce((sum, num) => sum + num.cnt, 0);
            };

            return {
                props,
                table,
                chartLayout,
                platformList,
                numberFormat,
                chartData,
            };
        },
    };
</script>

<style scoped>
    .flex.row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        gap: 40px;
        padding-top: 20px;
    }

    .flex.row:first-child {
        padding-top: 0;
    }

    #board_layer .board_table {
        max-height: 100px;
    }

    .board_graph_list {
        width: 80%;
    }

    #board_layer table.board_table thead th {
        background-color: #012f5c;
        color: #ffffff;
        font-size: 16px;
        font-weight: 700;
        line-height: 1.2;

        border: 1px solid #dfdfdf;
        height: auto;
    }

    #board_layer table.board_table tbody tr td {
        background-color: #ffffff;
        color: #012f5c;
        font-size: 16px;
        font-weight: 700;
        border: 1px solid #dfdfdf;
        height: auto;
    }

    .table_wrap {
        display: flex;
        flex-direction: column;
        align-items: start;
        gap: 20px;
        width: 30%;
    }
</style>
